const appSettings = {
  ...((window as any)?.wvusFlexCheckoutSettings || {}),
  eventData: ((window as any)?.wvusChosenEventData?.[0] || {}),
  tourData: ((window as any)?.wvusTourData || {}),
  ...((window as any)?.wvusCobrand && {cobrand: (window as any).wvusCobrand} || {}),
  allowMultipleQuantity: ['1', 'true', 1, true].includes((window as any)?.wvusFlexCheckoutSettings?.allowMultipleQuantity),
  checkoutFlow: (window as any)?.wvusFlexCheckoutSettings?.checkoutFlow ? (window as any)?.wvusFlexCheckoutSettings.checkoutFlow : "PhotoFirst",
  enableCCAuth: ['1', 'true', 1, true].includes((window as any)?.wvusFlexCheckoutSettings?.enableCCAuth),
  showSmsPreference: !!['1', 'true', 1, true].includes((window as any)?.wvusFlexCheckoutSettings?.showSmsPreference),
  orderPhotoUploadEnabled: !!['1', 'true', 1, true].includes((window as any)?.wvusFlexCheckoutSettings?.orderPhotoUploadEnabled),
  sponsoredChildData: ((window as any)?.wvusFlexCheckoutSettings?.sponsoredChildData || {}),
  REJECT_ERROR_MESSAGE: "We're having trouble seeing you in this photo. Please upload a different photo so that your child can easily identify you.",
  SERVICE_ERROR_MESSAGE: "Something went wrong. Please try again.",
  DEFAULT_ERROR_MESSAGE: "An error has occurred. Please try again or ask a volunteer for help."
}

export default appSettings;